import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';

export function useGetNumberOfSlidesForActiveSlideshowItem(slideType?: ITEM_TYPE.IMAGE | ITEM_TYPE.IMAGESLIDE | ITEM_TYPE.VIDEOSLIDE): number | undefined {
  const activeItemId = useSingleActivePosterItemId();

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId ?? ''];
    if (item && item.gitype === ITEM_TYPE.SLIDESHOW) {
      const copyItem = item as SlideshowItemObject;
      if (!slideType) {
        return Object.keys(copyItem.slides.slidesHashMap).length;
      }

      let sum = 0;
      for (const eachItem of Object.values(copyItem.slides.slidesHashMap)) {
        if (eachItem.gitype === slideType) {
          sum += 1;
        }
      }
      return sum;
    }
    return undefined;
  });
}
